const style = { color: "#FFF" };
export const disbursementColumns = [
  {
    name: (
      <div style={style}>
        Disbursement
        <br /> Date
      </div>
    ),
    cell: (row) => row["date"],
    sortable: true,
    sortFunction: (a, b) => new Date(b.date) - new Date(a.date),
  },
  {
    name: (
      <div style={style}>
        Disbursement
        <br /> Account<br /> Number
      </div>
    ),
    cell: (row) => row["accountNumber"],
  },
  {
    name: <div style={style}>Total Net<br /> Amount</div>,
    cell: (row) => row["totalNetAmount"],
  },
  {
    name: (
      <div style={style}>
        Total Agent
        <br />
        Commission
      </div>
    ),
    cell: (row) => row["totalAgentCommission"],
  },
  {
    name: (
      <div style={style}>
        Total Operator
        <br />
        Commission
      </div>
    ),
    cell: (row) => row["totalOperatorCommission"],
  },
  {
    name: (
      <div style={style}>
        Total Paid
        <br /> Amount
      </div>
    ),
    cell: (row) => row["totalPaidAmount"],
  },
  {
    name: <div style={style}>Adjustment</div>,
    cell: (row) => row["adjustment"],
  },
  {
    name: <div style={style}>Status</div>,
    cell: (row) => row["status"],
  },
];
export const topLevelDisbursementColumns = [
  {
    name: <div style={style}>Province</div>,
    cell: (row) => row["province"],
  },
  {
    name: <div style={style}>District</div>,
    cell: (row) => row["district"],
  },
  {
    name: <div style={style}>Sector</div>,
    cell: (row) => row["sector"],
  },
  {
    name: <div style={style}>Cell</div>,
    cell: (row) => row["cell"],
  },
  {
    name: (
      <div style={style}>
        Disbursement
        <br /> Date
      </div>
    ),
    cell: (row) => row["date"],
    sortable: true,
    sortFunction: (a, b) => new Date(b.date) - new Date(a.date),
  },
  {
    name: (
      <div style={style}>
        Disbursement
        <br /> Account
        <br /> Number
      </div>
    ),
    cell: (row) => row["accountNumber"],
  },
  {
    name: (
      <div style={style}>
        Total Net
        <br /> Amount
      </div>
    ),
    cell: (row) => row["totalNetAmount"],
  },
  {
    name: (
      <div style={style}>
        Total Agent
        <br />
        Commission
      </div>
    ),
    cell: (row) => row["totalAgentCommission"],
  },
  {
    name: (
      <div style={style}>
        Total Operator
        <br />
        Commission
      </div>
    ),
    cell: (row) => row["totalOperatorCommission"],
  },
  {
    name: (
      <div style={style}>
        Total Paid
        <br /> Amount
      </div>
    ),
    cell: (row) => row["totalPaidAmount"],
  },
  {
    name: <div style={style}>Adjustment</div>,
    cell: (row) => row["adjustment"],
  },
  {
    name: <div style={style}>Status</div>,
    cell: (row) => row["status"],
  },
];
export const exportDisbursementData = [
  {
    label: "Province",
    key: "province",
  },
  {
    label: "District",
    key: "district",
  },
  {
    label: "Sector",
    key: "sector",
  },
  {
    label: "Cell",
    key: "cell",
  },
  {
    label: "Disbursement Account Number",
    key: "accountNumber",
  },
  {
    label: "Transfer Id",
    key: "transferId",
  },
  {
    label: "Disbursement Date",
    key: "date",
  },
  {
    label: "Total Net Amount",
    key: "totalNetAmount",
  },
  {
    label: "Total Agent Commission",
    key: "totalAgentCommission",
  },
  {
    label: "Total Operator Commission",
    key: "totalOperatorCommission",
  },
  {
    label: "Total Paid Amount",
    key: "totalPaidAmount",
  },
  {
    label: "Adjustment",
    key: "adjustment",
  },
  {
    label: "Status",
    key: "status",
  },
];

